import * as React from "react";

import {I18NString} from "./Utils";
import {ApiClient} from "../services/ApiClient";
import { IDispatcher } from './controls/extensions/Dispatcher';

export interface IControlError {
    isError: boolean;
    message: string;
    isFrontValidation?: boolean;
}

export interface ControlErrorListItem extends IControlError{
    controlId: string;
}

export interface IControlSchema {
    id: string;
    type: string;
    contentNumb: string;
    disableNumber?: boolean;
    title: I18NString;
    required: boolean;
    viewableFor: Array<string>,
    visible?:boolean,
    rule?:{
        controlTergetId: string;
        option: number;
        value: string;
    },
    columns?: Array<any>
}

export interface ValidationResult {
    message: string;
}


export interface IControlCreateHandler {
    (schema: IControlSchema, api: ApiClient, dispatcher:IDispatcher, error: IControlError | undefined, visited: boolean): React.ReactElement<any>;
}

export function createControl(schema: IControlSchema, 
                            api: ApiClient, 
                            dispatcher:IDispatcher,
                            errors: Dictionary<IControlError | undefined>,
                            values: any,
                            visited: Dictionary<boolean>,
                            allVisited: boolean) : React.ReactElement<any> {

    const type = schema.type.toUpperCase();
    switch(type) {
        case 'PANEL': return createPanel(schema, api, dispatcher, errors, values, visited, allVisited);
        case 'DYNAMICGRIDPANEL': return createDynamicGrid(schema, api, dispatcher, errors, values, visited, allVisited);
        case 'TOTALHEADER': return createTotalHeader(schema, api, dispatcher, values);
        case 'GROUP': return createGroup(schema, api, dispatcher, errors, values, values, allVisited);
        default:
            return  _controls[type](schema, api, dispatcher, errors[schema.id], allVisited || visited[schema.id]);
    }
}

/* Controls */
import {createTextBox} from "./controls/standart/TextBox";
import {createDropBox} from "./controls/standart/DropBox";
import {createObjectControl} from "./controls/standart/ObjectControl";
import {createServiceTable} from "./controls/service/ServiceTable";
import { createCalendar } from './controls/standart/Calendar/';
import { createCheckbox } from './controls/standart/Checkbox';
import { createRadiobutton } from './controls/standart/Radiobutton';
import { createGrid } from './controls/standart/Grid';
import { createPanel } from './controls/standart/Panel';
import { createMultiFiles } from './controls/standart/MultipleFiles';
import { createLabel } from './controls/standart/Label';
import { createTelephone } from './controls/extensions/Telephone';
import { createGroup } from './controls/standart/Group';
import { createDynamicGrid } from './controls/standart/DynamicGridPanel';
import { createTotalHeader } from './controls/standart/TotalHeader';
import {Dictionary} from "../types/Dictionary";

const _controls : {[type: string]: IControlCreateHandler} = {
    "TEXTBOX": createTextBox,
    "TEXTAREA": createTextBox,
    "NUMBER": createTextBox,
    "DROPBOX": createDropBox,
    "FILE": createMultiFiles,
    "OBJECT": createObjectControl,
    "SERVICETABLE": createServiceTable,
    "CALENDAR": createCalendar,
    "CHECKBOX": createCheckbox,
    "GRID": createGrid,
    "RADIOBUTTON": createRadiobutton,
    "LABEL": createLabel,
    "TELEPHONE": createTelephone,
};


// WEBPACK FOOTER //
// ./src/components/Controls.tsx